export default __webpack_public_path__ + "static/media/gallery_04.8a4fb098.jpg";